import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';

export const useIsCareCollectionsEnabled = () => {
  const { data, isLoading } = useFeatureFlagQuery('care_collections_enabled');

  return data || isLoading;
};
